import { createFileRoute } from '@tanstack/react-router'
import { FaqPageStructured } from '@/components/infoPages/FaqPageStructured'
import { withPublicPageSeo } from '@/modules/seo'

const FaqPageWithSeo = withPublicPageSeo('faq', FaqPageStructured)

export const Route = createFileRoute('/$lang/faq')({
  component: FaqPageWithSeo,
})
